import Icons from '@/constants/Icons';
import RouteNames from '@/constants/RouteNames';
import AppAction from '@/models/core/AppAction';
import { usePermissions } from '@/composables/usePermissions';

type EmployeeActionParams = {
  employeeId: string;
  employeeUid: string;
};

export const employeeCreateAction = () => {
  const { canCreateEmployee } = usePermissions();

  return new AppAction({
    allowed: canCreateEmployee.value,
    icon: Icons.Core.Create,
    name: RouteNames.Employee.Create,
    route: { name: RouteNames.Employee.Create },
  });
};

export const employeeEditAction = (params: Partial<EmployeeActionParams>) => {
  const { canUpdateEmployee } = usePermissions();

  return new AppAction({
    allowed: canUpdateEmployee.value,
    icon: Icons.Core.Edit,
    name: RouteNames.Employee.Edit,
    route: { name: RouteNames.Employee.Edit, params },
  });
};

export const employeeListAction = () => {
  const { canReadEmployee } = usePermissions();

  return new AppAction({
    allowed: canReadEmployee.value,
    icon: Icons.Employee,
    name: RouteNames.Employee.List,
    route: { name: RouteNames.Employee.List },
  });
};
